/** @jsxImportSource @emotion/react */
import React from 'react'

import * as styles from './styles'

export default function Emoji30() {
  return (
    <svg width="100%" height="100%" viewBox="0 0 45 45" css={styles.svg}>
      <g transform="matrix(1,0,0,1,-876.855,-3495.83)">
        <g transform="matrix(0.683279,0,0,0.683279,373.769,3232.44)">
          <g transform="matrix(0.937093,0,0,0.937093,145.847,25.4079)">
            <g opacity="0.75">
              <g transform="matrix(1,0,0,1,0.5,0.5)">
                <path
                  d="M684.08,423.41c-0.237,-0.085 -0.487,-0.129 -0.739,-0.129c-0.928,0 -1.758,0.592 -2.061,1.469c-2.481,7 -9.143,11.707 -16.57,11.707c-7.427,0 -14.089,-4.707 -16.57,-11.707c-0.351,-0.796 -1.143,-1.313 -2.013,-1.313c-1.207,0 -2.2,0.993 -2.2,2.2c0,0.19 0.024,0.379 0.073,0.563c3.122,8.73 11.443,14.591 20.715,14.591c9.272,0 17.593,-5.861 20.715,-14.591c0.398,-1.136 -0.206,-2.397 -1.34,-2.8"
                  css={styles.svg}
                />
              </g>
              <g transform="matrix(1,0,0,1,0.5,0.5)">
                <path
                  d="M664.71,383.75c-19.277,0 -35.14,15.863 -35.14,35.14c0,19.277 15.863,35.14 35.14,35.14c19.277,0 35.14,-15.863 35.14,-35.14c0,-0.003 0,-0.007 0,-0.01c-0.022,-19.267 -15.873,-35.114 -35.14,-35.13m0,65.88c-16.869,0 -30.75,-13.881 -30.75,-30.75c0,-16.869 13.881,-30.75 30.75,-30.75c16.869,0 30.75,13.881 30.75,30.75c-0.016,16.863 -13.887,30.734 -30.75,30.75"
                  css={styles.svg}
                />
              </g>
              <g transform="matrix(1,0,0,1,0.5,0.5)">
                <path
                  d="M648.69,416.05l5,-5l5,5c0.417,0.407 0.977,0.637 1.56,0.64c0.58,-0.002 1.137,-0.232 1.55,-0.64c0.853,-0.853 0.853,-2.257 0,-3.11l-6.59,-6.59c-0.853,-0.853 -2.257,-0.853 -3.11,0l-6.58,6.59c-0.355,0.402 -0.551,0.92 -0.551,1.456c0,1.207 0.993,2.2 2.2,2.2c0.534,0 1.05,-0.194 1.451,-0.546"
                  css={styles.svg}
                />
              </g>
              <g transform="matrix(1,0,0,1,0.5,0.5)">
                <path
                  d="M670.65,416.05l5,-5l5,5c0.401,0.352 0.917,0.546 1.451,0.546c1.207,0 2.2,-0.993 2.2,-2.2c0,-0.536 -0.196,-1.054 -0.551,-1.456l-6.59,-6.59c-0.409,-0.414 -0.968,-0.647 -1.55,-0.647c-0.582,0 -1.141,0.233 -1.55,0.647l-6.59,6.59c-0.476,0.417 -0.749,1.021 -0.749,1.654c0,1.206 0.993,2.2 2.2,2.2c0.631,0 1.232,-0.271 1.649,-0.744"
                  css={styles.svg}
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}
